<template>
  <div class="how_step article">
    <div class="row">
      
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 app_icon_p">
        <img class="install_img"
          :src="app_root + '/assets/common/img/install_photoplus.png'"
        />
      </div>

      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <p class="app_title">
          <LabelFunMessage fcontId="0" msgkey="85" />
        </p>

        <p class="indent_caption">
          <slot></slot>
        </p>
        <p>
            <a
              class="btn btn-info btn-lg btn-download"
              v-on:click="trackGa4AppDownloadEvent()"
              v-bind:href="photoPlusDownloadLink"
              target="_blank"
              rel="noopener"

            >
            <LabelFunMessage fcontId="0" msgkey="161" />&nbsp;&raquo;
            </a>
          </p>
      </div>
    </div>
  </div>
</template>

<script>
import LabelFunMessage from "./LabelFunMessage";
import { mapState } from "vuex";

export default {
  name: "AppDownloadPhotoPlus",
  components: {
    LabelFunMessage
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
    fcontId: function () {
      return this.$route.path.match(/\/\d+/).shift().slice(1);
    },

    
//add
...mapState(["os"]),
    isPc: function () {
      return this.os == "ws" || this.os == "mi";
    },
    isWindows: function () {
      return this.os == "ws";
    },
    isMac: function () {
      return this.os == "mi";
    },

    photoPlusDownloadLink: function () {
      let query = [
        { key: "CTI", value: "104" },
      ];
      if (this.isWindows) {
        query = query.concat([
          { key: "OSC", value: "W864" },
          { key: "WSI", value: "1" },
          { key: "OSV", value: "WIN64_6.2" },
          { key: "OATR", value: "9200_64_0.0_CLI" },
          { key: "PRN", value: "Photo_Plus_Download" }
        ]);
      } else if (this.isMac) {
        query = query.concat([
          { key: "OSV", value: "MACINTEL_10.13.6" },
          { key: "PRN", value: "Photo_Plus_Update" }
        ]);
      }
      const pram = query.map((q) => `${q.key}=${q.value}`).join("&");
      return `http://go.epson.com/redirect.aspx?` + pram;
    },
//add end


  },
  methods: {
    trackGa4AppDownloadEvent: function () {
      this.$gtag.event("app_download", {
        app_name: "Photo Plus",
        location_id: "article",
        article_no: this.fcontId,
        site_id: "gallery"
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.install_img {
  padding: 0px;
}
</style>